import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { JenisBBM } from "@master-data/jenis-bbm/models/jenis-bbm.model";
import { JenisKendaraanInventaris } from "app/view-model/master-data/jenis-kendaraan-inventaris/jenis-kendaraan-inventaris.viewmodel";
import { UangJalanLangsirViewModel } from "app/view-model/master-data/uang-jalan-langsir/uang-jalan-langsir.view-model";
import { FilterGetUangJalanTradoMobilisasi } from "app/view-model/master-data/uang-jalan-trado/uang-jalan-trado.view-model";
import { NotificationFireStore } from 'app/view-model/notification/notification';
import { KonfigurasiViewModel } from "app/view-model/pengaturan/konfigurasi/konfigurasi-view-model";
import { ReturSlipUangJalanViewModel } from "app/view-model/transaksi/armada-berangkat/non-trado/retur-slip-uang-jalan.view-model";
import { FilterBrowseUangJalanMobilisasi, ResponseBrowseUangJalanMobilisasi } from "app/view-model/transaksi/armada-berangkat/non-trado/slip-uang-jalan.view-model";
import { ReturUangJalanTradoViewModel } from "app/view-model/transaksi/armada-berangkat/trado/retur-slip-uang-jalan-trado-view-model";
import { SlipUangJalanTradoViewModel } from "app/view-model/transaksi/armada-berangkat/trado/slip-uang-jalan-trado-view-model";
import { KontrakTradoFilter } from "app/view-model/transaksi/kontrak-trado/kontrak-trado-data-view-model";
import { GetBiayaEkspedisiViewModel, PengajuanPembayaranEkspedisiFilter } from "app/view-model/transaksi/pengajuan-pembayaran-ekspedisi/pengajuan-pembayaran-ekspedisi.viewmodel";
import { BehaviorSubject, Observable } from "rxjs";
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: "root"
})

export class PublicService {
    // [x: string]: any;
    public menu_list: Array<any> = [];
    pageType: string;
    routeParams: any;
    jenisPI: any = ["LOKAL", "IMPORT", "EXPORT"];
    NoPhotoAvailableBase64 = "data:image/png;base64,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";
    firebaseToken: string = null;

    // cabangListRFID: string[] = [
    //   "KTM",
    //   "KT",
    //   "SMP",
    //   "SMP S4",
    //   "KM",
    //   "KM S4"
    // ];

  countries = [
    { name: 'Afghanistan', code: 'AF' },
    { name: 'Åland Islands', code: 'AX' },
    { name: 'Albania', code: 'AL' },
    { name: 'Algeria', code: 'DZ' },
    { name: 'American Samoa', code: 'AS' },
    { name: 'AndorrA', code: 'AD' },
    { name: 'Angola', code: 'AO' },
    { name: 'Anguilla', code: 'AI' },
    { name: 'Antarctica', code: 'AQ' },
    { name: 'Antigua and Barbuda', code: 'AG' },
    { name: 'Argentina', code: 'AR' },
    { name: 'Armenia', code: 'AM' },
    { name: 'Aruba', code: 'AW' },
    { name: 'Australia', code: 'AU' },
    { name: 'Austria', code: 'AT' },
    { name: 'Azerbaijan', code: 'AZ' },
    { name: 'Bahamas', code: 'BS' },
    { name: 'Bahrain', code: 'BH' },
    { name: 'Bangladesh', code: 'BD' },
    { name: 'Barbados', code: 'BB' },
    { name: 'Belarus', code: 'BY' },
    { name: 'Belgium', code: 'BE' },
    { name: 'Belize', code: 'BZ' },
    { name: 'Benin', code: 'BJ' },
    { name: 'Bermuda', code: 'BM' },
    { name: 'Bhutan', code: 'BT' },
    { name: 'Bolivia', code: 'BO' },
    { name: 'Bosnia and Herzegovina', code: 'BA' },
    { name: 'Botswana', code: 'BW' },
    { name: 'Bouvet Island', code: 'BV' },
    { name: 'Brazil', code: 'BR' },
    { name: 'British Indian Ocean Territory', code: 'IO' },
    { name: 'Brunei Darussalam', code: 'BN' },
    { name: 'Bulgaria', code: 'BG' },
    { name: 'Burkina Faso', code: 'BF' },
    { name: 'Burundi', code: 'BI' },
    { name: 'Cambodia', code: 'KH' },
    { name: 'Cameroon', code: 'CM' },
    { name: 'Canada', code: 'CA' },
    { name: 'Cape Verde', code: 'CV' },
    { name: 'Cayman Islands', code: 'KY' },
    { name: 'Central African Republic', code: 'CF' },
    { name: 'Chad', code: 'TD' },
    { name: 'Chile', code: 'CL' },
    { name: 'China', code: 'CN' },
    { name: 'Christmas Island', code: 'CX' },
    { name: 'Cocos (Keeling) Islands', code: 'CC' },
    { name: 'Colombia', code: 'CO' },
    { name: 'Comoros', code: 'KM' },
    { name: 'Congo', code: 'CG' },
    { name: 'Congo, The Democratic Republic of the', code: 'CD' },
    { name: 'Cook Islands', code: 'CK' },
    { name: 'Costa Rica', code: 'CR' },
    { name: 'Cote D\'Ivoire', code: 'CI' },
    { name: 'Croatia', code: 'HR' },
    { name: 'Cuba', code: 'CU' },
    { name: 'Cyprus', code: 'CY' },
    { name: 'Czech Republic', code: 'CZ' },
    { name: 'Denmark', code: 'DK' },
    { name: 'Djibouti', code: 'DJ' },
    { name: 'Dominica', code: 'DM' },
    { name: 'Dominican Republic', code: 'DO' },
    { name: 'Ecuador', code: 'EC' },
    { name: 'Egypt', code: 'EG' },
    { name: 'El Salvador', code: 'SV' },
    { name: 'Equatorial Guinea', code: 'GQ' },
    { name: 'Eritrea', code: 'ER' },
    { name: 'Estonia', code: 'EE' },
    { name: 'Ethiopia', code: 'ET' },
    { name: 'Falkland Islands (Malvinas)', code: 'FK' },
    { name: 'Faroe Islands', code: 'FO' },
    { name: 'Fiji', code: 'FJ' },
    { name: 'Finland', code: 'FI' },
    { name: 'France', code: 'FR' },
    { name: 'French Guiana', code: 'GF' },
    { name: 'French Polynesia', code: 'PF' },
    { name: 'French Southern Territories', code: 'TF' },
    { name: 'Gabon', code: 'GA' },
    { name: 'Gambia', code: 'GM' },
    { name: 'Georgia', code: 'GE' },
    { name: 'Germany', code: 'DE' },
    { name: 'Ghana', code: 'GH' },
    { name: 'Gibraltar', code: 'GI' },
    { name: 'Greece', code: 'GR' },
    { name: 'Greenland', code: 'GL' },
    { name: 'Grenada', code: 'GD' },
    { name: 'Guadeloupe', code: 'GP' },
    { name: 'Guam', code: 'GU' },
    { name: 'Guatemala', code: 'GT' },
    { name: 'Guernsey', code: 'GG' },
    { name: 'Guinea', code: 'GN' },
    { name: 'Guinea-Bissau', code: 'GW' },
    { name: 'Guyana', code: 'GY' },
    { name: 'Haiti', code: 'HT' },
    { name: 'Heard Island and Mcdonald Islands', code: 'HM' },
    { name: 'Holy See (Vatican City State)', code: 'VA' },
    { name: 'Honduras', code: 'HN' },
    { name: 'Hong Kong', code: 'HK' },
    { name: 'Hungary', code: 'HU' },
    { name: 'Iceland', code: 'IS' },
    { name: 'India', code: 'IN' },
    { name: 'Indonesia', code: 'ID' },
    { name: 'Iran, Islamic Republic Of', code: 'IR' },
    { name: 'Iraq', code: 'IQ' },
    { name: 'Ireland', code: 'IE' },
    { name: 'Isle of Man', code: 'IM' },
    { name: 'Israel', code: 'IL' },
    { name: 'Italy', code: 'IT' },
    { name: 'Jamaica', code: 'JM' },
    { name: 'Japan', code: 'JP' },
    { name: 'Jersey', code: 'JE' },
    { name: 'Jordan', code: 'JO' },
    { name: 'Kazakhstan', code: 'KZ' },
    { name: 'Kenya', code: 'KE' },
    { name: 'Kiribati', code: 'KI' },
    { name: 'Korea, Democratic People\'S Republic of', code: 'KP' },
    { name: 'Korea, Republic of', code: 'KR' },
    { name: 'Kuwait', code: 'KW' },
    { name: 'Kyrgyzstan', code: 'KG' },
    { name: 'Lao People\'S Democratic Republic', code: 'LA' },
    { name: 'Latvia', code: 'LV' },
    { name: 'Lebanon', code: 'LB' },
    { name: 'Lesotho', code: 'LS' },
    { name: 'Liberia', code: 'LR' },
    { name: 'Libyan Arab Jamahiriya', code: 'LY' },
    { name: 'Liechtenstein', code: 'LI' },
    { name: 'Lithuania', code: 'LT' },
    { name: 'Luxembourg', code: 'LU' },
    { name: 'Macao', code: 'MO' },
    { name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK' },
    { name: 'Madagascar', code: 'MG' },
    { name: 'Malawi', code: 'MW' },
    { name: 'Malaysia', code: 'MY' },
    { name: 'Maldives', code: 'MV' },
    { name: 'Mali', code: 'ML' },
    { name: 'Malta', code: 'MT' },
    { name: 'Marshall Islands', code: 'MH' },
    { name: 'Martinique', code: 'MQ' },
    { name: 'Mauritania', code: 'MR' },
    { name: 'Mauritius', code: 'MU' },
    { name: 'Mayotte', code: 'YT' },
    { name: 'Mexico', code: 'MX' },
    { name: 'Micronesia, Federated States of', code: 'FM' },
    { name: 'Moldova, Republic of', code: 'MD' },
    { name: 'Monaco', code: 'MC' },
    { name: 'Mongolia', code: 'MN' },
    { name: 'Montserrat', code: 'MS' },
    { name: 'Morocco', code: 'MA' },
    { name: 'Mozambique', code: 'MZ' },
    { name: 'Myanmar', code: 'MM' },
    { name: 'Namibia', code: 'NA' },
    { name: 'Nauru', code: 'NR' },
    { name: 'Nepal', code: 'NP' },
    { name: 'Netherlands', code: 'NL' },
    { name: 'Netherlands Antilles', code: 'AN' },
    { name: 'New Caledonia', code: 'NC' },
    { name: 'New Zealand', code: 'NZ' },
    { name: 'Nicaragua', code: 'NI' },
    { name: 'Niger', code: 'NE' },
    { name: 'Nigeria', code: 'NG' },
    { name: 'Niue', code: 'NU' },
    { name: 'Norfolk Island', code: 'NF' },
    { name: 'Northern Mariana Islands', code: 'MP' },
    { name: 'Norway', code: 'NO' },
    { name: 'Oman', code: 'OM' },
    { name: 'Pakistan', code: 'PK' },
    { name: 'Palau', code: 'PW' },
    { name: 'Palestinian Territory, Occupied', code: 'PS' },
    { name: 'Panama', code: 'PA' },
    { name: 'Papua New Guinea', code: 'PG' },
    { name: 'Paraguay', code: 'PY' },
    { name: 'Peru', code: 'PE' },
    { name: 'Philippines', code: 'PH' },
    { name: 'Pitcairn', code: 'PN' },
    { name: 'Poland', code: 'PL' },
    { name: 'Portugal', code: 'PT' },
    { name: 'Puerto Rico', code: 'PR' },
    { name: 'Qatar', code: 'QA' },
    { name: 'Reunion', code: 'RE' },
    { name: 'Romania', code: 'RO' },
    { name: 'Russian Federation', code: 'RU' },
    { name: 'RWANDA', code: 'RW' },
    { name: 'Saint Helena', code: 'SH' },
    { name: 'Saint Kitts and Nevis', code: 'KN' },
    { name: 'Saint Lucia', code: 'LC' },
    { name: 'Saint Pierre and Miquelon', code: 'PM' },
    { name: 'Saint Vincent and the Grenadines', code: 'VC' },
    { name: 'Samoa', code: 'WS' },
    { name: 'San Marino', code: 'SM' },
    { name: 'Sao Tome and Principe', code: 'ST' },
    { name: 'Saudi Arabia', code: 'SA' },
    { name: 'Senegal', code: 'SN' },
    { name: 'Serbia and Montenegro', code: 'CS' },
    { name: 'Seychelles', code: 'SC' },
    { name: 'Sierra Leone', code: 'SL' },
    { name: 'Singapore', code: 'SG' },
    { name: 'Slovakia', code: 'SK' },
    { name: 'Slovenia', code: 'SI' },
    { name: 'Solomon Islands', code: 'SB' },
    { name: 'Somalia', code: 'SO' },
    { name: 'South Africa', code: 'ZA' },
    { name: 'South Georgia and the South Sandwich Islands', code: 'GS' },
    { name: 'Spain', code: 'ES' },
    { name: 'Sri Lanka', code: 'LK' },
    { name: 'Sudan', code: 'SD' },
    { name: 'Suriname', code: 'SR' },
    { name: 'Svalbard and Jan Mayen', code: 'SJ' },
    { name: 'Swaziland', code: 'SZ' },
    { name: 'Sweden', code: 'SE' },
    { name: 'Switzerland', code: 'CH' },
    { name: 'Syrian Arab Republic', code: 'SY' },
    { name: 'Taiwan, Province of China', code: 'TW' },
    { name: 'Tajikistan', code: 'TJ' },
    { name: 'Tanzania, United Republic of', code: 'TZ' },
    { name: 'Thailand', code: 'TH' },
    { name: 'Timor-Leste', code: 'TL' },
    { name: 'Togo', code: 'TG' },
    { name: 'Tokelau', code: 'TK' },
    { name: 'Tonga', code: 'TO' },
    { name: 'Trinidad and Tobago', code: 'TT' },
    { name: 'Tunisia', code: 'TN' },
    { name: 'Turkey', code: 'TR' },
    { name: 'Turkmenistan', code: 'TM' },
    { name: 'Turks and Caicos Islands', code: 'TC' },
    { name: 'Tuvalu', code: 'TV' },
    { name: 'Uganda', code: 'UG' },
    { name: 'Ukraine', code: 'UA' },
    { name: 'United Arab Emirates', code: 'AE' },
    { name: 'United Kingdom', code: 'GB' },
    { name: 'United States', code: 'US' },
    { name: 'United States Minor Outlying Islands', code: 'UM' },
    { name: 'Uruguay', code: 'UY' },
    { name: 'Uzbekistan', code: 'UZ' },
    { name: 'Vanuatu', code: 'VU' },
    { name: 'Venezuela', code: 'VE' },
    { name: 'Viet Nam', code: 'VN' },
    { name: 'Virgin Islands, British', code: 'VG' },
    { name: 'Virgin Islands, U.S.', code: 'VI' },
    { name: 'Wallis and Futuna', code: 'WF' },
    { name: 'Western Sahara', code: 'EH' },
    { name: 'Yemen', code: 'YE' },
    { name: 'Zambia', code: 'ZM' },
    { name: 'Zimbabwe', code: 'ZW' }
  ];

    ListNotification: any[] = [];
    constructor(
        private httpClient: HttpClient,
    ) {

    }

    private errorSubject = new BehaviorSubject<any>(null);
    private requestSubject = new BehaviorSubject<any>(null);
    request$ = this.requestSubject.asObservable();
    error$ = this.errorSubject.asObservable();

    setError(error: any) {
      this.errorSubject.next(error);
    }

    setRequest(request) {
      this.requestSubject.next(request);
    }

    toQueryString = (obj: any) => "?".concat(Object.keys(obj).map(e => `${encodeURIComponent(e)}=${encodeURIComponent(obj[e])}`).join("&"));

    stringToNumber(value: any,decimal_point: number = 0){
      if(typeof(value) === "undefined"){
          return value;
      }
      else if(typeof(value)==="string" && decimal_point > 0){
          // value = value.replace(/\./g, "")
          return parseFloat(parseFloat(value.replace(/\,/g,".")).toFixed(decimal_point));
      }
      else if (typeof(value) === "string") {
          // console.log(value)
          // value = value.replace(/\./g, "")
          return parseFloat(value.replace(/\,/g, "."));
      }
      return value;
    }
    // stringToNumber(value: any, decimal_point: number = 0) {
    //   if (typeof (value) === "undefined") {
    //     return value;
    //   }
    //   else if (typeof (value) === "string" && decimal_point > 0) {
    //     // value = value.replace(/\./g, "")
    //     return parseFloat(parseFloat(value).toFixed(decimal_point));
    //   }
    //   else if (typeof (value) === "string") {
    //     // value = value.replace(/\./g, "")
    //     return parseFloat(parseFloat(value).toFixed(2));
    //   }
    //   return value;
    // }
    
    numberToString(value: any, decimal_point: number = 0){
        if(typeof(value) === "undefined"){
            return value;
        }
        else if(typeof(value)==="number" && decimal_point > 0){
            return (value.toFixed(decimal_point).replace(/\./g,","));
        }
        else if (typeof(value) === "number") {
            return (value.toString().replace(/\./g, ","));
        }
        return value;
    }

    calculatePrecise(a: number | string, b: number | string): number {
      return +(Number(a) - Number(b)).toFixed(2);
    }

    // Start: Local Storage Area
    getLocalCabang(param: string){
        return JSON.parse(localStorage.getItem("cabang"))[param];
    }
    getLocalUser(param: string): any{
        return JSON.parse(localStorage.getItem("currentUser"))[param];
    }
    // End: Local Storage Area

    getBiayaEkspedisi(param: GetBiayaEkspedisiViewModel): Observable<any> {
        let endpoint = '/BiayaEkspedisiContainer/GetBiayaEkspedisi?';
        for (let [key, value] of Object.entries(param)) {
            endpoint += key + '=' + value + '&';
        }
        return this.httpClient.get<any>(
            endpoint, { responseType: 'json' }
        );
    }
    getMenu(dtParams: any): Observable<any> {
        return this.httpClient.get<any>(
            "/Public/GrupMenu?comloc_id=" + dtParams,
            { responseType: "json" }
        );
    }

    getCompany(): Observable<any> {
        return this.httpClient.get<any>("/Public/GetCompany", {
            responseType: "json"
        });
    }

    getCabang(transporter_id: string): Observable<any> {
        return this.httpClient.get<any>(
            "/Armada/GetCabang?transporter_id=" + transporter_id,
            { responseType: "json" }
        );
    }

    browseCabang(comloc_id: string): Observable<any> {
        return this.httpClient.get<any>("/Public/BrowseComLoc/" + comloc_id, {
            responseType: "json"
        });
    }

    browsePengajuanPembayaranEkspedisi(comloc_id: string, filter: PengajuanPembayaranEkspedisiFilter, sortColumn: string = 'pengajuan_pembayaran_ekspedisi_id', sortOrder = 'desc', pageNumber = 0, pageSize = 10): Observable<any> {
        return this.httpClient.post<any>("/PengajuanPembayaranEkspedisi/BrowsePengajuanPembayaranEkspedisi/" + comloc_id, { filter, sortColumn, sortOrder, pageNumber, pageSize }, { responseType: "json", observe: "response" }).pipe(map(response => {
            return response.body;
        }));
    }

    browsePIRevisi(pengajuan_pembayaran_ekspedisi_id: any, filter: KontrakTradoFilter, sortColumn: string = 'pengajuan_pembayaran_ekspedisi_id', sortOrder = 'desc', pageNumber = 0, pageSize = 10): Observable<any> {
        return this.httpClient.post<any>("/PengajuanPembayaranEkspedisi/BrowsePIRevisi/" + pengajuan_pembayaran_ekspedisi_id, { filter, sortColumn, sortOrder, pageNumber, pageSize }, { responseType: 'json', observe: 'response' }).pipe(map(response => {
            return response.body;
        }));
    }

    browseUser(): Observable<any> {
        return this.httpClient.get<any>("/Public/BrowseUser/", {
            responseType: "json"
        });
    }

    browseUserSearch(user: string): Observable<any> {
        return this.httpClient.get<any>("/Public/BrowseUser?searchstring=" + user, {
            responseType: "json"
        });
    }

    browseCustomer(nama_customer: string, comloc_id: string): Observable<any> {
        return this.httpClient.get<any>("/Pelanggan/Browse/" + nama_customer + "?comloc_id=" + comloc_id, {
            responseType: "json"
        });
    }

    browseEkspedisi(comloc_id: string, nama_ekspedisi: string): Observable<any> {
        return this.httpClient.get<any>("/Ekspedisi/Browse/" + nama_ekspedisi + "?comloc_id=" + comloc_id, {
            responseType: 'json'
        })
    }

    browseJenisBiayaEkspedisi(jenis_biaya_ekspedisi: string) {
        return this.httpClient.get<any>("/JenisBiayaEkspedisi/Browse?searchstring=" + jenis_biaya_ekspedisi, {
            responseType: 'json'
        })
    }
    browseKomoditi(nama_komoditi: string, comloc_id: string): Observable<any> {
        return this.httpClient.get<any>("/Komoditi/Browse/" + nama_komoditi + "?comloc_id=" + comloc_id, {
            responseType: "json"
        });
    }

    browseLokasi(nama_lokasi: string, comloc_id: string): Observable<any> {
        return this.httpClient.get<any>("/Lokasi/Browse/" + nama_lokasi + "?comloc_id=" + comloc_id, {
            responseType: "json"
        });
    }

    browsePI(comloc_id: string, searchstring: string): Observable<any> {
      return this.httpClient.get<any>('/PI/Browse/' + comloc_id + "?searchstring=" + searchstring, { responseType: "json" });
    }
    
    browseSatuan(nama_satuan: string, comloc_id: string): Observable<any> {
        return this.httpClient.get<any>("/Satuan/Browse/" + nama_satuan + "?comloc_id=" + comloc_id, {
            responseType: "json"
        });
    }

    browseJenisArmada(jenis: string, comloc_id: string): Observable<any> {
        return this.httpClient.get<any>("/JenisArmada/Browse/" + jenis + "?comloc_id=" + comloc_id, {
            responseType: "json"
        });
    }

    browseJenisOATrado(jenis_oa_trado: string = ''): Observable<any> {
        return this.httpClient.post<any>(`/JenisOATrado/Browse/${jenis_oa_trado}`, null, { responseType: 'json'})
    }

    browseMerkArmada(merk: string = "%20"): Observable<any> {
        return this.httpClient.post<any>(`/MerkArmada/Browse/${merk}`, null, { responseType: 'json'})
    }
    
    browseContainer(jenis_kontainer: any, comloc_id: string): Observable<any> {
        return this.httpClient.get<any>("/JenisKontainer/Browse/" + jenis_kontainer + "?comloc_Id=" + comloc_id, { responseType: "json" });
    }

    browseSupirArmadaTrado(no_polisi: string, tanggal: string): Observable<any> {
        return this.httpClient.get<any>("/Public/BrowseSupirArmadaTrado/" + tanggal + "/" + no_polisi, { responseType: "json" });
    }

    browseArmada(search_string: string, isTradoOnly: boolean = false): Observable<any> {
        return this.httpClient.get<any>(`/Armada/Browse/${search_string}?isTradoOnly=${isTradoOnly}`, { responseType: 'json' })
    }

    browseSupirArmadaById(tanggal: string, armadaId: number | number): Observable<any> {
        return this.httpClient.get<any>(`/Public/BrowseSupirArmadaById/${tanggal}/${armadaId}`, { responseType: 'json' })
    }

    browseSubDO(comloc_id: string, sub_do_nomor: string) {
        return this.httpClient.get<any>("/SubDO/Browse/" + comloc_id + "/" + sub_do_nomor, { responseType: "json" });
    }

    getCmbKeterangan(jenis_gantung: string, comloc_id: string): Observable<any> {
        return this.httpClient.get<any>("/KeteranganArmadaGantung/Browse" + "?JenisGantung=" + jenis_gantung + "&comloc_id=" + comloc_id, {
            responseType: "json"
        });
    }

    getCmbJenisArmada(): Observable<any> {
        return this.httpClient.get<any>("/Public/GetJenisArmada", {
            responseType: "json"
        });
    }

    getCmbJenisKendaraanInventaris(jenis: string = ''): Observable<Array<JenisKendaraanInventaris>> {
      return this.httpClient.post<Array<JenisKendaraanInventaris>>(`/JenisKendaraanInventaris/Browse?jenis=${jenis}`, null, { responseType: 'json' });
    }

    getCmbJenisArmadabytransporter(comloc_id: string): Observable<any> {
        return this.httpClient.get<any>("/Public/GetJenisArmadaPerCabang/" + comloc_id, {
            responseType: "json"
        });
    }

    getCmbGrupJenisArmadaPerCabang(cabang: string): Observable<any> {
        return this.httpClient.get<any>("/Public/GetGrupJenisArmadaPerCabang/" + cabang,
            { responseType: "json" }
        );
    }

    getCmbLokasiBrowse(param: string, comloc_id: string): Observable<any> {
        return this.httpClient.get<any>("/Lokasi/Browse/" + param + "?comloc_id=" + comloc_id, {
            responseType: "json"
        });
    }

    getCmbKomiditiBrowse(param: string, comloc_id: string): Observable<any> {
        return this.httpClient.get<any>("/Komoditi/Browse/" + param + "?comloc_id=" + comloc_id, {
            responseType: "json"
        });
    }

    getCmbPelangganBrowse(param: string, comloc_id: string): Observable<any> {
        return this.httpClient.get<any>("/Pelanggan/Browse/" + param + "?comloc_id=" + comloc_id, {
            responseType: "json"
        });
    }

    getCmbCabang(transporter_id: string): Observable<any> {
        return this.httpClient.get<any>("/Public/GetComLoc?transporter_id=" + transporter_id, {
            responseType: "json"
        });
    }

    getCmbCabangPerPT(comloc_id: string): Observable<any> {
      return this.httpClient.get<any>(`/Public/GetComLocPerTransporter?comloc_id=${comloc_id}`, {
        responseType: "json"
      })
    }

    getCmbCabangIsiBBM(comloc_id: string): Observable<any> {
        return this.httpClient.get<any>("/Public/GetComLocPerTransporter?comloc_id=" + comloc_id, {
            responseType: "json"
        });
    }

    getCmbSatuan(comloc_id: string): Observable<any> {
        return this.httpClient.get<any>("/Satuan/ListSatuan?comloc_id=" + comloc_id, {
            responseType: "json"
        });
    }

    getCmbJenisArmadaForm(comloc_id: string): Observable<any> {
        return this.httpClient.get<any>("/JenisArmada/ListJenisArmada?comloc_id=" + comloc_id, {
            responseType: "json"
        });
    }
    getDetailPengajuanPembayaranEkspedisiById(param: any): Observable<any> {
        return this.httpClient.post<any>('/PengajuanPembayaranEkspedisi/GetPengajuanPembayaranEkspedisiById/' + param, { responseType: "json" });
    }
    getCmbNoPolisi(param: string): Observable<any> {
        return this.httpClient.get<any>("/Armada/Browse/" + param, {
            responseType: "json"
        });
    }

    getCmbSupir(param: string): Observable<any> {
        return this.httpClient.get<any>("/Supir/Browse/" + param, {
            responseType: "json"
        });
    }

    getCmbSupirArmadaTrado(param: string, tanggal): Observable<any> {
        return this.httpClient.get<any>("/Public/BrowseSupirArmadaTrado/" + tanggal + "/" + param, { responseType: "json" });
    }

    getCmbGandengan(param: string): Observable<any> {
        return this.httpClient.get<any>("/Gandengan/Browse/" + param, {
            responseType: "json"
        });
    }

    getCmbJenisKontainer(comloc_id: string): Observable<any> {
        return this.httpClient.get<any>('/PI/GetJenisKontainer?cabang=' + comloc_id, { responseType: "json" });
    }

    browseTahun() {
        var tahuns: any[] = [];
        var curentyear = new Date().getFullYear();
        var tahunmin = curentyear - 10;
        var tahunmax = curentyear + 10;
        var selected = "";
        for (let index = tahunmin; index <= tahunmax; index++) {
            if (index == curentyear) {
                selected = "selected";
            } else {
                selected = "";
            }
            tahuns.push({ tahun: index, selected: selected });
        }
        return tahuns;
    }

    browseBulan() {
        var bulans: any[] = [
            { id: 1, text: "Januari" },
            { id: 2, text: "Februari" },
            { id: 3, text: "Maret" },
            { id: 4, text: "April" },
            { id: 5, text: "Mei" },
            { id: 6, text: "Juni" },
            { id: 7, text: "Juli" },
            { id: 8, text: "Agustus" },
            { id: 9, text: "September" },
            { id: 10, text: "Oktober" },
            { id: 11, text: "November" },
            { id: 12, text: "Desember" }
        ];
        return bulans;
    }

    browseNoPolisi(nomor_polisi: string): Observable<any> {
        return this.httpClient.get<any>("/Armada/Browse/" + nomor_polisi, {
            responseType: "json"
        });
    }

    browseSubPengangkutan(sub_pengangkutan: any, comloc_id: string): Observable<any> {
        return this.httpClient.get<any>('/SubPengangkutan/Browse/' + sub_pengangkutan + "?comloc_id=" + comloc_id, { responseType: "json" });
    }

    BrowseJenisBBM(jenis_bbm: string = '%20'): Promise<JenisBBM[]> {
      return new Promise((resolve, reject) => {
        this.httpClient.post<JenisBBM[]>(`/JenisBBM/Browse/${jenis_bbm}`, null, { responseType: 'json' }).subscribe((resp) => {
          resolve(resp);
        }, (err) => reject(err))
      })
    }

    getCmbGrupJenisArmada(): Observable<any> {
        return this.httpClient.get<any>("/Public/GetGrupJenisArmada", {
            responseType: "json"
        });
    }

    getCmbJenisArmadaPercabang(cabang: string): Observable<any> {
        return this.httpClient.get<any>("/Public/GetJenisArmadaPerCabang/" + cabang, { responseType: "json" });
    }

    getLokasi(transporter_id: string): Observable<any> {
        return this.httpClient.get<any>('/Public/GetLoc?transporter_id=' + transporter_id, { responseType: "json" });
    }

    GetHargaBBMTerbaru(jenisbbm: string, tgl: string, comloc_Id: string): Observable<any> {
      return this.httpClient.get<any>(`/HargaBBM/GetHargaBBMTerbaru?jenisbbm=${jenisbbm}&batastanggal=${tgl}&comloc_id=${comloc_Id}`, { responseType: 'json'})
    }

    GetHargaBBMTerbaru2(jenis_bbm: string,
      batas_tgl: string,
      comloc_id: string,
      jenis_armada_id: number,
      jenis_kendaraan_inventaris_id: number,
      isi_dari: string
    ): Observable<any> {
      return this.httpClient.get<any>(`/HargaBBM/GetHargaBBMTerbaru?jenisbbm=${jenis_bbm}&batastanggal=${batas_tgl}&comloc_id=${comloc_id}&jenis_armada_id=${jenis_armada_id}&jenis_kendaraan_inventaris_id=${jenis_kendaraan_inventaris_id}&isidari=${isi_dari}`)
    }

    GetBBMPrice(jenisbbm: string, date: string, comloc_Id: string, isidari: string): Observable<any> {
        return this.httpClient.get<any>("/HargaBBM/GetHargaBBMTerbaru?jenisbbm=" + jenisbbm + "&batastanggal=" + date + "&comloc_id=" + comloc_Id + "&isidari=" + isidari, { responseType: "json" });
    }

    browseJenisUangTambah(filter: string, cabang: string): Observable<any> {
        return this.httpClient.get<any>("/JenisUangTambahan/Browse/" + filter + "?comloc_id=" + cabang, {
            responseType: "json"
        });
    }
    
    GetUangJalan(
      suj_tgl: string,
      comloc_id: string,
      jenis_armada_id: number,
      tonase_fisik: number,
      status_muatan: string,
      status_fisik: string,
      via: string,
      perjalanan: string,
      merk: string,
      lokasi_muat_id: number,
      lokasi_bongkar_id: number,
      komoditi_id: number,
      include_bbm: boolean = true
    ): Observable<any> {
        return this.httpClient.get<any>(
            "/UangJalan/GetUJ?tgl_batasan=" + suj_tgl +
            "&Cabang=" + comloc_id +
            "&MuatId=" + lokasi_muat_id +
            "&BongkarId=" + lokasi_bongkar_id +
            "&KomoditiId=" + komoditi_id +
            "&JenisArmadaId=" + jenis_armada_id +
            "&Tonase=" + tonase_fisik +
            "&StatusMuatan=" + status_muatan +
            "&StatusFisik=" + status_fisik +
            "&Via=" + via +
            "&Perjalanan=" + perjalanan +
            "&Merk=" + merk+
            "&IncludeBBM=" + include_bbm,
            { responseType: "json" }
        );
    }

    GetUangJalanLangsir(
      suj_tgl: string,
      comloc_id: string,
      jenis_armada_id: number,
      tonase_fisik: number,
      status_muatan: string,
      status_fisik: string,
      lokasi_muat_id: number,
      lokasi_bongkar_id: number,
      komoditi_id: number,
      include_bbm: boolean = true
    ): Observable<UangJalanLangsirViewModel> {
        return this.httpClient.get<any>(
            "/UangJalanLangsir/GetUJ?tgl_batasan=" + suj_tgl +
            "&Cabang=" + comloc_id +
            "&MuatId=" + lokasi_muat_id +
            "&BongkarId=" + lokasi_bongkar_id +
            "&KomoditiId=" + komoditi_id +
            "&JenisArmadaId=" + jenis_armada_id +
            "&Tonase=" + tonase_fisik +
            "&StatusMuatan=" + status_muatan +
            "&StatusFisik=" + status_fisik +
            "&IncludeBBM=" + include_bbm,
            { responseType: "json" }
        );
    }

    /**
     * API untuk get master uang jalan mobilisasi, mungkin saat pilih via dan perjalanan bisa ditambahkan hit api ini
     * @param data - filterBrowseUangJalanMobilisasi
     * @returns data master uang jalan mobilisasi yg sesuai kriteria
     */
    GetUangJalanMobilisasi(data: FilterBrowseUangJalanMobilisasi): Observable<ResponseBrowseUangJalanMobilisasi> {
      return this.httpClient.post<ResponseBrowseUangJalanMobilisasi>(
        `/UangJalanMobilisasi/Browse`,
        data,
        { responseType: 'json' }
      );
    }

    GetUangJalanTrado(param: SlipUangJalanTradoViewModel, comloc_id: string, include_bbm: boolean = true): Observable<any> {
        return this.httpClient.get<any>(
            "/UangJalanTrado/GetUJ?tgl_batasan=" + param.suj_trado_tgl +
            "&Cabang=" + comloc_id +
            "&MuatId=" + param.lokasi_asal_id +
            "&BongkarId=" + param.lokasi_tujuan_id +
            "&JenisContainerId=" + param.jenis_container_id_1 +
            "&JumlahContainer=" + param.jlh_container +
            "&StatusMuatan=" + param.status_muatan +
            "&JenisTrip=" + param.jenis_trip +
            "&JenisPI=" + param.jenis_pi_1 +
            "&Merk=" + param.merk_armada +
            "&IncludeBBM=" + include_bbm,
            { responseType: "json" }
        );
    }

    GetUangJalanTradoMobilisasi(data: FilterGetUangJalanTradoMobilisasi) {
      return this.httpClient.post<any>(
        `/UangJalanMobilisasiTrado/Browse`,
        data,
        { responseType: 'json' }
      );
    }

    requestPermission() {
        // this.angularFireMessaging.requestToken.subscribe(
        //     (token) => {
        //         var currentUser = JSON.parse(localStorage.currentUser);
        //         if (currentUser.firebaseToken != token) { 
        //             environment.firebaseToken = token;
        //             currentUser.firebaseToken = environment.firebaseToken
        //             localStorage.currentUser = JSON.stringify(currentUser);
        //             this.SimpanFirebaseToken(environment.firebaseToken).subscribe((resp) => console.log("New Token:", resp))
        //         }
        //     },
        //     (err) => {
        //         console.error('Unable to get permission to notify.', err);
        //     }
        // );
    }

    receiveMessage() {
        // this.angularFireMessaging.messages.subscribe(
        //     (payload) => {
        //         console.log("new message received. ", payload);
        //         this.currentMessage.next(payload);
        //     })
    }

    public SimpanFirebaseToken(param: string) {
        return this.httpClient.post<any>("/UserManagement/User/SimpanFirebaseToken?firebase_token=" + param, null, { responseType: "json", observe: "response" }).pipe(map(response => {

        }))
    }

    createNotification(docEmail: string, notification: NotificationFireStore, TypeIdTransaction: string): void {
        // // var testing = this.firestore.collection('notifications/' + docEmail + '/datanotif').add({ ...notification });
        // this.notificationsRef.doc(docEmail).collection("datanotif").doc(TypeIdTransaction).set({ ...notification });
    }

    deleteNotification(docEmail: string, notification: NotificationFireStore, TypeIdTransaction: string): void {
        // this.notificationsRef.doc(docEmail).collection("datanotif").doc(TypeIdTransaction).delete();
    }
    // getNotificationList(docEmail: string): AngularFirestoreCollection<NotificationFireStore> {
    //    // return this.notificationsRef.doc(docEmail).collection("datanotif");
    // }

    getTransaksiByID(type: string, id: number, comloc_Id: string, refreshMasterQtyBBMMax: boolean = true  ) {
        if (type == "SUJ" || type == "UANG JALAN") {
            return this.httpClient.post<any>(`/ArmadaBerangkat/NonTrado/SUJ/GetSUJById/${comloc_Id}/${id}?refreshMasterQtyBBMMax=${refreshMasterQtyBBMMax}`, null, { responseType: "json", observe: "response" }).pipe(map(response => {
                return response.body;
            }))
        }
        else if (type == "SUJTrado" || type == "UANG JALAN TRADO") {
            return this.httpClient.post<any>("/ArmadaBerangkat/Trado/SUJ/GetSUJById/" + comloc_Id + "/" + id, null, { responseType: "json", observe: "response" }).pipe(map(response => {
                return response.body;
            }))
        }

        else if (type == "SUT" || type == "TAMBAHAN UANG JALAN") {
            return this.httpClient.post<any>("/ArmadaBerangkat/NonTrado/SUT/GetSUTById/" + comloc_Id + "/" + id, null, { responseType: "json", observe: "response" }).pipe(map(response => {
                return response.body;
            }))
        }
        else if (type == "SUTTrado" || type == "TAMBAHAN UANG JALAN TRADO") {
            return this.httpClient.post<any>("/ArmadaBerangkat/Trado/SUT/GetSUTById/" + comloc_Id + "/" + id, null, { responseType: "json", observe: "response" }).pipe(map(response => {
                return response.body;
            }))
        }
        else if (type == "SUG" || type == "UANG GANTUNG") {
            return this.httpClient.post<any>("/SUG/NonTrado/GetSUGById/" + comloc_Id + "/" + id, null, { responseType: "json", observe: "response" }).pipe(map(response => {
                return response.body;
            }))
        }
        else if (type == "SUGTrado" || type == "UANG GANTUNG TRADO") {
            return this.httpClient.post<any>("/SUG/Trado/GetSUGById/" + comloc_Id + "/" + id, null, { responseType: "json", observe: "response" }).pipe(map(response => {
                return response.body;
            }))
        }
        else if (type == "SUB DO") {
            return this.httpClient.post<any>("/SubDO/GetSubDOById/" + id, null, { responseType: "json", observe: "response" }).pipe(map(response => {
                return response.body;
            }))
        }
        else if (type == "SUB PI") {
            return this.httpClient.post<any>("/SubPI/GetSubPIById/" + id, null, { responseType: "json", observe: "response" }).pipe(map(response => {
                return response.body;
            }))
        }
        else if (type == "PEMAKAIAN VOUCHER BBM") {
            return this.httpClient.post<any>("/PemakaianVoucherBBM/GetPemakaianVoucherBBMById/" + id, null, { responseType: "json", observe: "response" }).pipe(map(response => {
                return response.body;
            }))
        }
        else if ( type === "RETUR UANG JALAN") {
            return this.httpClient.post<ReturSlipUangJalanViewModel>(`/ArmadaBerangkat/NonTrado/RSUJ/GetRSUJById/${id}`, null, { responseType: 'json', observe: "response" }).pipe(map(response => {
              return response.body;
          }))
        }
        else if(type === 'RETUR UANG JALAN TRADO') {
            return this.httpClient.post<ReturUangJalanTradoViewModel>(`/ArmadaBerangkat/Trado/RSuJ/GetRSUJById/${id}`, null, { responseType: 'json', observe: 'response' }).pipe(map((resp) => {
              return resp.body;
            }))
        }
    }

    getSaldoPiutangSupir(comloc_id, supir_id): Observable<any> {
        return this.httpClient.post<any>(
            "/Supir/GetSaldoPiutang?supir_id=" + supir_id + "&comloc_id=" + comloc_id, null,
            { responseType: "json" }
        );
    }

    GetOtherTransporter(cabang: string): Observable<any> {
        return this.httpClient.get<any>("/Public/GetOtherTransporter?cabang=" + cabang, { responseType: "json" })
    };

    GetMerkArmada(comloc_id: string): Observable<any> {
        return this.httpClient.get<any>("/Public/GetMerkArmada/" + comloc_id, {
            responseType: "json"
        });
    }

    GetMerkArmadaTrado(comloc_id: string): Observable<any> {
        return this.httpClient.get<any>("/Public/GetMerkArmadaTrado/" + comloc_id, {
            responseType: "json"
        });
    }

    getCmbKaryawan(param: string): Observable<any> {
        return this.httpClient.get<any>("/Public/BrowseKaryawan?searchstring=" + param, {
            responseType: "json"
        });
    }

    getTanggal(): Observable<any> {
        return this.httpClient.post<any>("/Public/GetDate", {
            responseType: "json"
        });
    }

    getTanggalJam(): Observable<any> {
        return this.httpClient.post<any>("/Public/GetDateTime", {
            responseType: "json"
        });
    }

    GetJenisKontainer(comloc_id: string): Observable<any> {
        return this.httpClient.get<any>('/PI/GetJenisKontainer?cabang=' + comloc_id, { responseType: "json" });
    }

    // GetJenisOATrado(): Observable<any> {
    //     return this.httpClient.post<any>('/JenisOATrado/GetJenisOATrado', { responseType: "json" });
    // }

    GetKartuByArmadaId(armada_id: number): Observable<any> {
        return this.httpClient.post<any>('/RFID/GetKartuByArmadaId?armada_id=' + armada_id, { responseType: "json" });
    }

    GetKartuByKendaraanInventarisId(kendaraan_inventaris_id: number): Observable<any> {
        return this.httpClient.post<any>('/RFID/GetKartuByKendaraanInventarisId?kendaraan_inventaris_id=' + kendaraan_inventaris_id, { responseType: "json" });
    }

    updateStatusVocuherRFID(param): Observable<any> {
        return this.httpClient.post<any>("/RFID/UpdateStatus", param, { responseType: "json" })
    }

    getStatusVoucher(jenis_transaksi: string, transaksi_id: number): Observable<any> {
        return this.httpClient.post<any>("/RFID/getStatusVoucher?jenis_transaksi=" + jenis_transaksi + "&transaksi_id=" + transaksi_id, null, { responseType: "json" })
    }

    async checkCabangRFID(cabang: string){
        try{
          const response: KonfigurasiViewModel = await this.getKonfigurasiCabang(cabang).toPromise();
          // console.log(response)
          return response.link_spbu
        } catch(e) {
          console.log(e)
        }
        return false
        // const cbgFilter = this.cabangListRFID.filter(cbng => cbng === cabang);
        // if (cbgFilter.length > 0) {
        //     return true
        // }
        // else {
        //     return false
        // }
    }

    getKonfigurasiCabang(comloc_id: string): Observable<any> {
        return this.httpClient.post<any>("/Konfigurasi/GetKonfigurasiCabang/" + comloc_id, null, { responseType: "json", observe: "response" }).pipe(map(response => {
            return response.body;
        }))
    }

    saveRFIDHilang(jenis_transaksi: string, transaksi_id: number, alasan: string): Observable<any> {
        return this.httpClient.post<any>("/RFID/Hilang/" + jenis_transaksi + "/" + transaksi_id + "?alasan_hilang=" + alasan, null, { responseType: "json", observe: "response" }).pipe(map(response => {
            return response.body;
        }))
    }

    getAllJenisArmada(): Observable<Array<{'jenis': string}>> {
      return this.httpClient.get<Array<{'jenis': string}>>('/Public/GetAllJenisArmada')
    }

    // record log hit api logkar
    recordLogkarApi(data) {
      return new Promise((resolve, reject) => {
        this.httpClient.post<any>(
          `/Logkar/InsertLog`,
          data,
          { responseType: 'json' }
        ).subscribe(
          resp => resolve(resp),
          error => reject(error)
        )
      })
    }

    browseSeal(value: string, comlocId: string): Observable<any> {
      return this.httpClient.get<any>(
        `/Seal/Browse/${value}?comloc_id=${comlocId}`,
        { responseType: "json" }
      )
    }
}